(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const tabs = [...root.querySelectorAll('[data-step]')];
    const steps = {
      browse: { title: 'Find the right blank.', copy: 'Know the garment? Search for it. Still looking? Filter by brand and category, then favourite the sets you use most.', items: ['Choose multiple brands and categories', 'Keep your go-to sets easy to find', 'Browse in a grid or a compact list'], alt: 'Pixel Sauce brand dropdown open inside Photoshop' },
      download: { title: 'Download it once. Keep it close.', copy: 'Download the set to your chosen library folder. Watch its progress in the panel, then find it in Downloads whenever you need it.', items: ['See how your download is progressing', 'Cancel if you change your mind', 'Return to your downloaded sets'], alt: 'Real Pixel Sauce mockup download with progress and cancel control' },
      views: { title: 'Pick a view. Start designing.', copy: 'Choose the angle you need and hit Open Mockup. The plugin opens a new copy in Photoshop and keeps the supporting files with it.', items: ['Find fronts and backs in separate groups', 'Open the view you need in Photoshop', 'Start fresh without changing the original'], alt: 'Real Pixel Sauce view selection with individual Open Mockup buttons' }
    };
    function select(tab, focus) {
      tabs.forEach(t => { t.setAttribute('aria-selected', String(t === tab)); t.tabIndex = t === tab ? 0 : -1; });
      const step = steps[tab.dataset.step];
      root.querySelector('#ps-step-title').textContent = step.title;
      root.querySelector('#ps-step-copy').textContent = step.copy;
      const list = root.querySelector('#ps-step-list'); list.replaceChildren(...step.items.map(text => { const item = document.createElement('li'); item.textContent = text; return item; }));
      const image = root.querySelector('#ps-demo-image'); image.src = tab.dataset.image; image.alt = step.alt;
      image.parentElement.dataset.zoom = tab.dataset.image;
      root.querySelector('#ps-demo-panel').setAttribute('aria-labelledby', tab.id);
      if (focus) tab.focus();
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        select(tabs[event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length], true);
      });
    });
    const dialog = root.querySelector('.ps-lightbox'); let trigger;
    root.querySelectorAll('[data-zoom]').forEach(button => button.addEventListener('click', () => {
      trigger = button;
      dialog.querySelector('img').src = button.dataset.zoom;
      dialog.querySelector('img').alt = button.querySelector('img').alt;
      dialog.showModal(); dialog.scrollTop = 0;
    }));
    dialog.querySelector('.ps-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => { if (trigger) trigger.focus(); });
  }
  document.querySelectorAll('.ps-plugin-landing').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.ps-plugin-landing').forEach(init));
})();
